import { MainPage } from '@/modules/main-page/types';
import { all_roles } from '@/utils';

const access_roles = {
  [MainPage.Pages.MAIN]: all_roles,
};

export default access_roles;
